import React, {MouseEventHandler,} from "react";
import {ClipLoader} from "react-spinners";
import "./style.scss";

interface ButtonProps {
    children: React.ReactNode;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    filled?: boolean;
    negative?: boolean;
    light?: boolean;
    disabled?: boolean;
    underlined?: boolean;
    loading?: boolean;
    type?: "button" | "submit" | "reset";
    backgroundColor?: string;
    borderColor?: string;
    className?: string;
}

const Button: React.FC<ButtonProps> = ({
                                           children,
                                           onClick,
                                           filled,
                                           negative,
                                           light,
                                           disabled,
                                           underlined,
                                           loading,
                                           type,
                                           backgroundColor,
                                           borderColor,
                                           className
                                       }) => {

    return (
        <button
            className={`
        button 
        ${negative ? "button--negative" : ""}
        ${light ? "button--light" : ""}
        ${disabled ? "button--disabled" : ""}
		${filled ? "button--filled" : ""} 
        ${underlined ? "button--underlined" : ""}
        ${className ? className : ""}
        `}
            onClick={onClick}
            disabled={disabled}
            type={type}
            style={{backgroundColor, borderColor}}
        >
            {!loading && children}
            {loading && <ClipLoader size={20} color={"#ffffff"} loading={true}/>}
        </button>
    );
};

export default Button;
